import { useTopic } from "@/hooks/useTopic";
import { GetWSMgr } from "@/Utils/StateLib";
import { QObjDBObject } from "@coreapp/CoreApp/QObjDBObject";
import { QPlanManager } from "@coreapp/CoreApp/QPlanManager";
import { useState } from "react";

export const readOverrides = (planMgr: QPlanManager) => {
  const overrideClass = planMgr.fOverrideClass;
  const objMgr = overrideClass?.GetObjMgr();

  if (!objMgr) {
    return [];
  }

  return objMgr.GetObjectList() ?? [];
};

export const usePlanOverrides = () => {
  const [overrides, setOverrides] = useState<QObjDBObject[]>(() => {
    const wsMgr = GetWSMgr();
    const planMgr = wsMgr?.GetPlanMgr();
    if (!planMgr) {
      return [];
    }

    return readOverrides(planMgr);
  });

  useTopic("loadedOverrides", (payload: { planMgr: QPlanManager }) => {
    const { planMgr } = payload;
    if (!planMgr) {
      return;
    }

    const newOverrides = readOverrides(planMgr);
    setOverrides(newOverrides);
  });

  return overrides;
};
